import { Code, ExternalLink } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';

const Projects = ({ projects, interests }) => {
  return (
    <section id="projects" className="py-20 bg-[#0D1117]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Projects & Interests
          </h2>
          <p className="text-lg text-white/70 max-w-3xl mx-auto">
            Innovative projects and diverse interests that fuel my curiosity and growth
          </p>
        </div>

        {/* Projects */}
        <div className="mb-16">
          <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3">
            <Code className="text-[#9A7B4F]" size={28} />
            Key Projects
          </h3>
          <div className="grid md:grid-cols-2 gap-6">
            {projects.map((project) => (
              <Card key={project.id} className="border-white/10 bg-white/5 backdrop-blur-sm shadow-xl hover:shadow-2xl transition-all hover:-translate-y-1">
                <CardHeader>
                  <CardTitle className="text-white flex items-center justify-between">
                    <span>{project.title}</span>
                    <ExternalLink className="text-[#9A7B4F]" size={20} />
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-white/70 mb-4 leading-relaxed">{project.description}</p>
                  <div className="flex flex-wrap gap-2">
                    {project.technologies.map((tech, idx) => (
                      <Badge
                        key={idx}
                        variant="secondary"
                        className="bg-[#9A7B4F]/20 text-[#C4A76C] hover:bg-[#9A7B4F]/30 border-none"
                      >
                        {tech}
                      </Badge>
                    ))}
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>

        {/* Interests */}
        <div className="bg-gradient-to-br from-[#9A7B4F] to-[#C4A76C] rounded-3xl p-8 md:p-12 text-white shadow-2xl">
          <h3 className="text-2xl font-bold mb-6 text-center">Beyond Work & Study</h3>
          <p className="text-center text-white/90 mb-8 max-w-2xl mx-auto">
            Diverse interests that keep me balanced, curious, and constantly learning
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {interests.map((interest, index) => (
              <div
                key={index}
                className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center hover:bg-white/20 transition-all hover:-translate-y-1 border border-white/20"
              >
                <div className="text-3xl mb-2">
                  {interest.icon === 'film' && '🎬'}
                  {interest.icon === 'music' && '🎹'}
                  {interest.icon === 'football' && '⚽'}
                  {interest.icon === 'waves' && '🏊'}
                  {interest.icon === 'brain' && '🧠'}
                  {interest.icon === 'bitcoin' && '🪙'}
                  {interest.icon === 'flag' && '⛳'}
                  {interest.icon === 'trophy' && '🏆'}
                </div>
                <p className="text-sm font-medium">{interest.name}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Projects;